import { render } from "./AppToastStack.vue?vue&type=template&id=54dca0ae&scoped=true"
import script from "./AppToastStack.vue?vue&type=script&lang=js"
export * from "./AppToastStack.vue?vue&type=script&lang=js"

import "./AppToastStack.vue?vue&type=style&index=0&id=54dca0ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54dca0ae"]])

export default __exports__